import { createContentObjectDetail } from 'models';
import { useMutation } from 'query';
import { getContentObject } from '../../services';
import { useContentObjectCache } from '../cache';

// TODO: will be deleted after rewrite whole program to the react query
export const useReloadContentObjectMutation = () => {
  const cache = useContentObjectCache();

  return useMutation<undefined, { filter: { id: string } }>({
    async mutationFn({ filter }) {
      const { data } = await getContentObject({ config: { params: {} }, routeParams: { id: filter.id } });

      cache.replace(createContentObjectDetail(data));
    },
  });
};
